import React from 'react';

export const FAQS = [
  {
    q: 'Can ConvoLines help me if I understand English but freeze when I speak?',
    a: 'Yes — that is exactly who it is built for. You practice real conversations out loud, so you get confident with how to pronounce the words and how to respond in that situation. With consistent practice, you start speaking instead of freezing.',
  },
  {
    q: 'What situations does ConvoLines cover?',
    a: 'Over 25 categories and 900+ conversations covering everyday moments: ordering food, calling a bank, doctor and clinic visits, rescheduling appointments, returning packages, job interviews, travel, customer support, and small talk.',
  },
  {
    q: 'How is this different from other English learning apps?',
    a: 'Most apps teach vocabulary and grammar you already know. ConvoLines starts from the situation instead, giving you the exact spoken lines a native speaker would use, plus a second natural way to say the same thing.',
  },
  {
    q: 'Is ConvoLines free?',
    a: 'Yes. Every category, conversation, quiz, audio clip, and role play is free, supported by ads. If you prefer practicing without ads, an optional Premium subscription removes them.',
  },
  {
    q: 'How much time do I need each day?',
    a: 'A few minutes. Completing one conversation or three quiz expressions counts as your day and keeps your streak going, so it fits around a commute or a coffee break.',
  },
  {
    q: 'Is ConvoLines available on iPhone and Android?',
    a: 'Yes, ConvoLines is available on iOS and Android.',
  },
];

const SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function Faq() {
  return (
    <section className="section faq" id="faq">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(SCHEMA) }}
      />
      <h2 className="section__title">Common questions</h2>
      <div className="faq-list">
        {FAQS.map((item) => (
          <details className="faq-item" key={item.q}>
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
